import { Flex } from "antd";
import dayjs from "dayjs";
import { FC } from "react";
import { SalesSKUInvoice } from "tm-shared/types";

import SumIcon from "@/assets/icons/sum.svg";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { StyledISIBlock, StyledISIModal, StyledISISum } from "./Styled";

interface InvoiceSKUInfoModalProps {
    modalKey: string;
    open: boolean;
    onClose: () => void;
    invoice: SalesSKUInvoice;
}

export const InvoiceSKUInfoModal: FC<InvoiceSKUInfoModalProps> = ({
    open,
    onClose,
    invoice,
}) => {
    if (!invoice) return null;

    const { contragent, marketAddress, invoiceCreatedAt, amount } = invoice;
    const formattedTime = invoiceCreatedAt
        ? dayjs(invoiceCreatedAt).format("HH:mm:ss")
        : "";

    return (
        <StyledISIModal
            open={open}
            onOk={onClose}
            onCancel={onClose}
            centered
            footer={null}
            destroyOnHidden
        >
            <Flex
                style={{ width: "100%", padding: "24px" }}
                vertical
                justify="flex-start"
                align="flex-start"
            >
                <PrimaryText fontSize={16}>{invoice.invoiceId}</PrimaryText>

                <StyledISIBlock align="flex-start" justify="flex-start">
                    <PrimaryText
                        fontSize={14}
                        fontWeight="500"
                        textAlign="left"
                    >
                        {contragent}
                    </PrimaryText>

                    <SecondaryText fontSize={14} fontWeight="400">
                        {marketAddress}
                    </SecondaryText>

                    <Flex
                        style={{ width: "100%" }}
                        align="center"
                        justify="space-between"
                    >
                        <SecondaryText fontSize={14} fontWeight="400">
                            {formattedTime}
                        </SecondaryText>

                        <Flex gap="4px" justify="center" align="center">
                            <img src={SumIcon} alt="sum" />
                            <StyledISISum>{amount.toFixed(2)} ₴</StyledISISum>
                        </Flex>
                    </Flex>
                </StyledISIBlock>
            </Flex>
        </StyledISIModal>
    );
};
